import React, { useState, useRef, useEffect, useCallback } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./rainexit.scss";
import Exitdetails from "./Exitdetails";
import Actionbreak from "./Actionbreak";
import Userslist from "./Userslist";
import apiClient from "../../../utils/apiClient.util";

const TIME_FILTERS = ["1H", "1D", "1W", "1M", "1Y"];

const getDateRange = (filter) => {
  const now = new Date();
  if (filter === "1H") return { startDate: new Date(now - 60 * 60 * 1000), endDate: now };
  if (filter === "1D") return { startDate: new Date(now - 24 * 60 * 60 * 1000), endDate: now };
  if (filter === "1W") return { startDate: new Date(now - 7 * 24 * 60 * 60 * 1000), endDate: now };
  if (filter === "1M") {
    const s = new Date(now); s.setMonth(s.getMonth() - 1);
    return { startDate: s, endDate: now };
  }
  if (filter === "1Y") {
    const s = new Date(now); s.setFullYear(s.getFullYear() - 1);
    return { startDate: s, endDate: now };
  }
  return {};
};

const Rainexit = () => {
  const [activeFilter, setActiveFilter] = useState("1H");
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [showcalendar, setShowCalendar] = useState(false);
  const [dateRangeState, setDateRangeState] = useState([
    { startDate: new Date(), endDate: new Date(), key: "selection" },
  ]);
  const [appliedDates, setAppliedDates] = useState(null);

  const calendarRef = useRef(null);

  // close calendar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    if (showcalendar) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showcalendar]);

  const fetchStats = useCallback(async () => {
    setStatsLoading(true);
    try {
      const params = {};
      if (activeFilter === "date" && appliedDates) {
        params.startDate = appliedDates.start.toISOString();
        const end = new Date(appliedDates.end);
        end.setHours(23, 59, 59, 999);
        params.endDate = end.toISOString();
      } else if (activeFilter !== "date") {
        const { startDate, endDate } = getDateRange(activeFilter);
        if (startDate) params.startDate = startDate.toISOString();
        if (endDate) params.endDate = endDate.toISOString();
      }
      const res = await apiClient.get("/rain-payback/dashboard/stats", { params });
      setStats(res.data.data);
    } catch (e) {
      console.error("Failed to fetch stats", e);
    } finally {
      setStatsLoading(false);
    }
  }, [activeFilter, appliedDates]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    setShowCalendar(false);
    setAppliedDates(null);
  };

  const handleDateRangeChange = (item) => {
    setDateRangeState([item.selection]);
    const { startDate, endDate } = item.selection;
    // close and apply once the user picks a full range (end differs from start)
    if (endDate && startDate.toDateString() !== endDate.toDateString()) {
      setAppliedDates({ start: startDate, end: endDate });
      setActiveFilter("date");
      setShowCalendar(false);
    }
  };

  return (
    <>
      <section className="mainrainexit">
        <div className="custom-container">
          <div className="toprainexit">
            <div className="leftheadings">
              <p className="premiumpara">Premium Projects</p>
              <h1 className="exithead">Rain exit dashboard</h1>
            </div>
            <div className="maintime">
              {TIME_FILTERS.map((filter) => (
                <button
                  key={filter}
                  className={`innertime${activeFilter === filter ? " active" : ""}`}
                  onClick={() => handleFilterClick(filter)}
                >
                  {filter}
                </button>
              ))}

              <div className="cal" ref={calendarRef}>
                <button
                  className={`innertime${activeFilter === "date" ? " active" : ""}`}
                  onClick={() => setShowCalendar(!showcalendar)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M11.1667 2.37333V1.33333C11.1667 1.05999 10.94 0.833328 10.6667 0.833328C10.3933 0.833328 10.1667 1.05999 10.1667 1.33333V2.33333H5.83332V1.33333C5.83332 1.05999 5.60666 0.833328 5.33332 0.833328C5.05999 0.833328 4.83332 1.05999 4.83332 1.33333V2.37333C3.03332 2.53999 2.15999 3.61333 2.02666 5.20666C2.01332 5.39999 2.17332 5.56 2.35999 5.56H13.64C13.8333 5.56 13.9933 5.39333 13.9733 5.20666C13.84 3.61333 12.9667 2.53999 11.1667 2.37333Z" fill={activeFilter === "date" ? "#329879" : "#869397"} />
                    <path d="M13.3333 6.56H2.66667C2.3 6.56 2 6.86 2 7.22666V11.3333C2 13.3333 3 14.6667 5.33333 14.6667H10.6667C13 14.6667 14 13.3333 14 11.3333V7.22666C14 6.86 13.7 6.56 13.3333 6.56ZM6.14 12.14C6.10667 12.1667 6.07333 12.2 6.04 12.22C6 12.2467 5.96 12.2667 5.92 12.28C5.88 12.3 5.84 12.3133 5.8 12.32C5.75333 12.3267 5.71333 12.3333 5.66667 12.3333C5.58 12.3333 5.49333 12.3133 5.41333 12.28C5.32667 12.2467 5.26 12.2 5.19333 12.14C5.07333 12.0133 5 11.84 5 11.6667C5 11.4933 5.07333 11.32 5.19333 11.1933C5.26 11.1333 5.32667 11.0867 5.41333 11.0533C5.53333 11 5.66667 10.9867 5.8 11.0133C5.84 11.02 5.88 11.0333 5.92 11.0533C5.96 11.0667 6 11.0867 6.04 11.1133C6.07333 11.14 6.10667 11.1667 6.14 11.1933C6.26 11.32 6.33333 11.4933 6.33333 11.6667C6.33333 11.84 6.26 12.0133 6.14 12.14ZM6.14 9.80666C6.01333 9.92666 5.84 10 5.66667 10C5.49333 10 5.32 9.92666 5.19333 9.80666C5.07333 9.68 5 9.50666 5 9.33333C5 9.16 5.07333 8.98666 5.19333 8.86C5.38 8.67333 5.67333 8.61333 5.92 8.72C6.00667 8.75333 6.08 8.8 6.14 8.86C6.26 8.98666 6.33333 9.16 6.33333 9.33333C6.33333 9.50666 6.26 9.68 6.14 9.80666ZM8.47333 12.14C8.34667 12.26 8.17333 12.3333 8 12.3333C7.82667 12.3333 7.65333 12.26 7.52667 12.14C7.40667 12.0133 7.33333 11.84 7.33333 11.6667C7.33333 11.4933 7.40667 11.32 7.52667 11.1933C7.77333 10.9467 8.22667 10.9467 8.47333 11.1933C8.59333 11.32 8.66667 11.4933 8.66667 11.6667C8.66667 11.84 8.59333 12.0133 8.47333 12.14ZM8.47333 9.80666C8.44 9.83333 8.40667 9.86 8.37333 9.88666C8.33333 9.91333 8.29333 9.93333 8.25333 9.94666C8.21333 9.96666 8.17333 9.98 8.13333 9.98666C8.08667 9.99333 8.04667 10 8 10C7.82667 10 7.65333 9.92666 7.52667 9.80666C7.40667 9.68 7.33333 9.50666 7.33333 9.33333C7.33333 9.16 7.40667 8.98666 7.52667 8.86C7.58667 8.8 7.66 8.75333 7.74667 8.72C7.99333 8.61333 8.28667 8.67333 8.47333 8.86C8.59333 8.98666 8.66667 9.16 8.66667 9.33333C8.66667 9.50666 8.59333 9.68 8.47333 9.80666ZM10.8067 12.14C10.68 12.26 10.5067 12.3333 10.3333 12.3333C10.16 12.3333 9.98667 12.26 9.86 12.14C9.74 12.0133 9.66667 11.84 9.66667 11.6667C9.66667 11.4933 9.74 11.32 9.86 11.1933C10.1067 10.9467 10.56 10.9467 10.8067 11.1933C10.9267 11.32 11 11.4933 11 11.6667C11 11.84 10.9267 12.0133 10.8067 12.14ZM10.8067 9.80666C10.7733 9.83333 10.74 9.86 10.7067 9.88666C10.6667 9.91333 10.6267 9.93333 10.5867 9.94666C10.5467 9.96666 10.5067 9.98 10.4667 9.98666C10.42 9.99333 10.3733 10 10.3333 10C10.16 10 9.98667 9.92666 9.86 9.80666C9.74 9.68 9.66667 9.50666 9.66667 9.33333C9.66667 9.16 9.74 8.98666 9.86 8.86C9.92667 8.8 9.99333 8.75333 10.08 8.72C10.2 8.66666 10.3333 8.65333 10.4667 8.68C10.5067 8.68666 10.5467 8.7 10.5867 8.72C10.6267 8.73333 10.6667 8.75333 10.7067 8.78C10.74 8.80666 10.7733 8.83333 10.8067 8.86C10.9267 8.98666 11 9.16 11 9.33333C11 9.50666 10.9267 9.68 10.8067 9.80666Z" fill={activeFilter === "date" ? "#329879" : "#869397"} />
                  </svg>
                </button>

                {showcalendar && (
                  <div className="set-custom-calendar-div">
                    <DateRange
                      editableDateInputs={true}
                      onChange={handleDateRangeChange}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRangeState}
                      maxDate={new Date()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <Exitdetails stats={stats} loading={statsLoading} />
          <Actionbreak stats={stats} loading={statsLoading} />
          <Userslist />
        </div>
      </section>
    </>
  );
};

export default Rainexit;
